module.exports = __webpack_public_path__ + "img/06.566a9eb3.jpg";